/** @jsx jsx */
import { jsx } from '@emotion/core';
import React from 'react';
import {
  Heading, MultiSelect, MultiSelectOption,
} from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { useEnhancedDataTableContext } from '../EnhancedDataTableContext';
import EnhancedToolbarStyles from '../../../styles/EnhancedDataTable/EnhancedTableToolbar/EnhancedTableToolbar';
import {
  getSelectedRowCnt, getSelectedRows,
} from '../EnhanceDataTableUtil';
import { formatCellData } from '../DataTableRowUtil';

const SelectionPreviewComponent = React.memo((props) => {
  const context = useEnhancedDataTableContext();
  const { tableNm } = context;
  const { handleRowCheckChange, openPopup } = props;
  const { tableData } = context;
  const { rowKeyCol } = context;
  const { selection } = context;
  const { checkable } = context;
  const { loginData } = context;
  const { timeZoneLocation: tzDbNm } = loginData?.userDetail?.timeZone || {};
  // const totalPage = Math.ceil(totalRows / itemsPerPage);
  if (selection && selection.preview
      // && totalPage > 1
      && getSelectedRowCnt(tableData) > 0
      && checkable) {
    return (
      <div id={`${tableNm}-selection-preview-component`} css={EnhancedToolbarStyles['.tableSelectionPreviewComponent']}>
        <div id={`${tableNm}-selection-preview-component`} css={EnhancedToolbarStyles['.tableSelectionPreview']}>
          <Heading
            id={`${tableNm}-selection-preview-pre-text`}
            level={1}
            headingStyle="heading1"
            css={openPopup ? EnhancedToolbarStyles['.selectionPreviewPipePaginationSelected'] : EnhancedToolbarStyles['.selectionPreviewPipe']}
          > |
          </Heading>
          <Heading
            id={`${tableNm}-selection-preview-pre-text`}
            level={4}
            headingStyle="heading3"
            css={EnhancedToolbarStyles['.itemsPerPageText']}
          > Your Selection(s)
          </Heading>
        </div>
        <div id={`${tableNm}-selection-preview-dropdown-div`} style={{ display: 'inline-block', width: '300px', margin: '8px' }}>
          <MultiSelect
            id={`${tableNm}-selection-preview-dropdown`}
            onChange={(key) => handleRowCheckChange({ currentTarget: { key } },
              { checked: true, id: key })}
          >
            { getSelectedRows(tableData).map((obj) => (
              <MultiSelectOption
                key={obj[rowKeyCol]}
                selected={true}
                id={obj[rowKeyCol]}
                label={selection?.label ? selection
                  .label.map((l) => formatCellData(
                    tableData.headers.find((h) => h.id === l), obj[l], false, tzDbNm))
                  .join(selection?.divider || ' ') : obj[rowKeyCol]}
                value={obj[rowKeyCol]}
              />
            ))}
          </MultiSelect>
        </div>
      </div>
    );
  }

  return (<div />);
});

SelectionPreviewComponent.displayName = 'SelectionPreviewComponent';

SelectionPreviewComponent.propTypes = {
  totalRows: PropTypes.number.isRequired,
  handleRowCheckChange: PropTypes.func.isRequired,
};

export default SelectionPreviewComponent;
